export default __webpack_public_path__ + "static/media/condizioni_generali_di_appalto_fincantieri_si_ita.fb950676.pdf";